<template>
  <div class="advance-reporting-kpi-card">
    <div class="kpi-header">
      <div class="kpi-icon">
        <KpiCardIcons :title="title" />
      </div>
      <span class="kpi-title">{{ title }}</span>
    </div>
    <div class="kpi-content">
      <div class="kpi-value">{{ formattedValue }}</div>
      <div class="kpi-trend" :class="isTrendPositive ? 'positive' : 'negative'">
        {{ trend }}
      </div>
    </div>
  </div>
</template>

<script>
import KpiCardIcons from "@/v3components/AdvanceReporting/KpiCardIcons.vue"
import { computed } from "vue"
export default {
  name: "KpiCard",
  components: {
    KpiCardIcons
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: 0
    },
    trend: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const isTrendPositive = computed(() => {
      return Number(parseInt(props.trend)) >= 0
    })
    const formattedValue = computed(() => {
      return Intl.NumberFormat("en-US").format(Number(parseInt(props.value)))
    })
    return {
      formattedValue,
      isTrendPositive
    }
  }
}
</script>
